import React from 'react';
import { Link } from 'react-router-dom';
// import './SuggestionCard.css';

const SuggestionCard = ({ suggestion }) => {
  const image = suggestion.image || '/static/placeholder.jpg';
  const link = `/media-list/${suggestion.type}#search=${encodeURIComponent(suggestion.title)}`;

  return (
    <div>
      <h2>Random Suggestion</h2>
      <div className="suggestion-card">
        <img src={image} alt={suggestion.title} />
        <div className="suggestion-info">
          <h3>{suggestion.title}</h3>
          <p>{suggestion.description || 'No description available.'}</p>
          <Link to={link} className="btn btn-primary">View</Link>
        </div>
      </div>
    </div>
  );
};

export default SuggestionCard;